import { Settings as SettingsIcon } from 'react-feather';
import { Outlet } from 'react-router-dom';
import { SettingsLayout, type SettingsNavItem } from '@trinity/chat-components/components/Settings';

const NAV_ITEMS: SettingsNavItem[] = [{ label: 'Account', to: '/settings/account', icon: SettingsIcon }];

export const SettingsScreen = () => {
  return (
    <SettingsLayout navItems={NAV_ITEMS}>
      <Outlet />
    </SettingsLayout>
  );
};
